import { ICellRenderer } from 'ag-grid-community';

export default class IconRenderer implements ICellRenderer {
  private eGui: HTMLElement;
  private iconMappingConfig: { [key: string]: { label: string; iconName: string; iconType: string } } = {};

  public init(params: any): void {
    this.eGui = document.createElement('div');
    this.eGui.style.cssText = `display: flex;
    width: 100%;
    height: 100%;
    gap: 8px;
    justify-content: center;
    align-items: center;
    height: 32px;
  `;
    if (params?.iconMappingConfig) {
      this.iconMappingConfig = params?.iconMappingConfig;
    }
    const icon = document.createElement('udp-icon');

    icon.iconType = this.iconMappingConfig[params.value]?.iconType;
    icon.iconName = this.iconMappingConfig[params.value]?.iconName;
    this.eGui.appendChild(icon);

    if (this.iconMappingConfig[params.value]?.label) {
      const text = document.createElement('p');
      text.innerHTML = this.iconMappingConfig[params.value]?.label;
      text.style.cssText = 'margin: 0px';
      this.eGui.appendChild(text);
    }  
  }

  public getGui(): HTMLElement {
    return this.eGui;
  }

  public refresh(): boolean {
    return true;
  }
}
